import { Box } from '@mui/material'
import TableCellMarkdown from './TableCellMarkdown.jsx'
import styles from './index.module.scss'

/**
 * @param {{ data: Record<string, unknown>[], headers: string[] }} props
 */
export default function TableGrid({ data, headers }) {
  if (!data?.length || !headers?.length) return null

  return (
    <Box className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map((header) => (
                <td key={`${rowIndex}-${header}`}>
                  <TableCellMarkdown text={String(row[header] ?? '')} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  )
}
